  // 获取 URL 参数
  function get_param() {
    let app_url = window.location.href;
    let paramObj = {};
    if (app_url.indexOf('?')!== -1) {
      let params = app_url.split('?')[1];
      let paramArray = params.split('&');
      for (let i = 0; i < paramArray.length; i++) {
        let param = paramArray[i].split('=');
        let key = decodeURIComponent(param[0]);
        let value = decodeURIComponent(param[1]);
        paramObj[key] = value;
      }
    }
    return paramObj;
  }

  // 隐藏指定类名的元素
  function hideElements(classNames) {
    try {
      classNames.forEach(className => {
        const elements = document.querySelectorAll(className);
        elements.forEach(item => {
          item.style.display = 'none';
        });
      });
    } catch (error) {
      console.error('隐藏元素时出现错误:', error);
    }
  }

  // h5的5.0及以下隐藏产品购买页面的客服按钮，顶、底部导航栏等
  function hiden_header() {
    let paramObj = get_param();
    try {
      const isApp = localStorage.getItem('equipment_type') === 'app' || paramObj['equipment_type'] === 'app';
      if (isApp) {
        if (paramObj['equipment_type'] === 'app') {
          localStorage.setItem('equipment_type', 'app');
        }
        //要隐藏部分的类名
        hideElements(['.app--hiden']);
      }
    } catch (error) {
      console.error('处理 hiden_header 时出现 localStorage 错误:', error);
    }
  }

  // 商城版本隐藏产品购买页面除了A+图部分以外的内容
  function hiden_beyond_A() {
    let paramObj = get_param();
    try {
      const platform = localStorage.getItem('platform');
      const isPlatformValid = platform === 'ios' || platform === 'android' || paramObj['platform'] === 'ios' || paramObj['platform'] === 'android';
        if (isPlatformValid) {
          if (paramObj['platform'] && !platform) {
            localStorage.setItem('platform', paramObj['platform']);
          }
          //要隐藏部分的类名
          hideElements([
            '.announcement-container', //顶部优惠横幅
            '.header', //顶部导航栏
            '.product-template', //产品信息
            '.app--hiden',
            '.customer_service', //客服按钮
            '.floatingNavigationBox', //A+图类型导航
            '.section_FAQ_box', //产品FAQ
            '.product__tech', //产品规格
            '.horizontal_video_products', //产品视频
            '.explore_list_products', //产品相关博客
            '.shopify-section--custom-liquid', //产品评论
            '.breadcrumb_box', //面包屑
            '.footer__container' //底部导航栏
          ]);
        }
    } catch (error) {
      console.error('处理 hiden_beyond_A 时出现 localStorage 错误:', error);
    }
  }

  hiden_header();
  hiden_beyond_A();
  
  

  
  